import { useState, useCallback } from 'react';

interface Toast {
  id: string;
  message: string;
  type: 'success' | 'error' | 'info';
}

export function useToast() {
  const [toasts, setToasts] = useState<Toast[]>([]);

  const showToast = useCallback((message: string, type: 'success' | 'error' | 'info' = 'info') => {
    const id = `toast-${Date.now()}-${Math.random()}`;
    setToasts((prev) => [...prev, { id, message, type }]);
  }, []);

  const removeToast = useCallback((id: string) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return { toasts, showToast, removeToast };
}

export function getErrorMessage(error: unknown): string {
  if (typeof error === 'object' && error !== null) {
    const err = error as any;
    if (err.response?.data?.message) {
      const message = err.response.data.message;
      return Array.isArray(message) ? message.join('. ') : String(message);
    }
    if (err.response?.status === 403) return 'Access denied. Please check your admin permissions.';
    if (err.response?.status === 503)
      return 'Service temporarily unavailable. Please try again later.';
    if (err.message) return err.message;
  }
  return 'An unexpected error occurred';
}
